<template>
  <div :class="['tender-section', isTemplate ? 'print-area' : '']" :section="section.Title">
    <component v-if="section.showContent !== false" :is="chapterComponent">
      <template #form-item="scope">
        <tender-form-item
          :chapter-index="chapterIndex"
          :section-index="sectionIndex"
          :property-key="scope.key"
          :attrs="scope"
        ></tender-form-item>
      </template>
    </component>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import TenderFormItem from './form-item'
export default {
  name: 'TenderSection',
  components: {
    TenderFormItem
  },
  props: {
    chapterIndex: {
      type: Number,
      default: 0
    },
    sectionIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState(['chapterComponents', 'isTemplate']),
    ...mapGetters(['chapters']),
    chapterComponent() {
      let {chapterComponents, chapterIndex, sectionIndex} = this
      return chapterComponents[chapterIndex][sectionIndex]
    },
    section() {
      let {chapters, chapterIndex, sectionIndex} = this
      return chapters[chapterIndex].Sections[sectionIndex]
    }
  }
}
</script>
<style lang="scss" scoped>
.tender-section  {
  margin-bottom: 15px;
  padding: 30px;
  background: white;
  page-break-inside: avoid;
  box-shadow: 0px 0px 5px 1px #aaabaf;
  .ts-title {
    margin: 20px 0;
    text-align: center;
    font: bold 21px/30px simsun;
  }
  &.print-area {
    padding: 0;
    box-shadow: none;    
  }
}
</style>